import memoize from 'transmute/memoize';
import { getMentionsPlugin } from 'hubspot-prosemirror/prosemirror/plugins/MentionsPlugin';
import { getMatchResults } from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import { AT_MENTION } from 'hubspot-prosemirror/prosemirror/utils/mentionsUtil';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import formatName from 'I18n/utils/formatName';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
// Adapted from FormatOwnerName in customer-data-objects
export const getUserSuggestedOption = memoize(owner => {
  const firstName = owner.firstName;
  const lastName = owner.lastName;
  const email = owner.email;
  const id = owner.ownerId;
  if (!firstName && !lastName && !email) {
    const label = '';
    return {
      id,
      name: label,
      searchText: label,
      text: label
    };
  } else {
    const formattedName = formatName({
      firstName,
      lastName
    });
    const labelWithEmail = email ? `${formattedName} (${email})` : formattedName;
    return {
      id,
      name: formattedName,
      searchText: labelWithEmail,
      text: formattedName
    };
  }
});
function OwnersNotFound({
  text
}) {
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx("div", {
      className: "suggestion-item",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "draftPlugins.tokenPlugin.atMentions.resultsZeroState.notFound",
        options: {
          search: text,
          uri: `/settings/${PortalIdParser.get()}/users/new`
        }
      })
    })
  );
}
export const configureMentionsPlugin = ({
  owners
}) => {
  const transformedUsers = owners.map(owner => {
    return getUserSuggestedOption(owner);
  });
  const atMentionPlugin = getMentionsPlugin({
    getSuggestions: (text, done) => {
      done(getMatchResults(text, transformedUsers));
    },
    type: AT_MENTION,
    NotFoundComponent: OwnersNotFound
  });
  return atMentionPlugin;
};